import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getInitials } from "@/utils/string.utils";
import { cn } from "@/lib/utils";
import { AvatarSize, AVATAR_SIZE_CLASSES } from "@/common/avatar.common";

interface UserAvatarProps {
  imageUrl?: string | null;
  name: string;
  size?: AvatarSize;
  onClick?: () => void;
  className?: string;
  fallbackClassName?: string;
}

export function UserAvatar({
  imageUrl,
  name,
  size = "md",
  onClick,
  className,
  fallbackClassName,
}: UserAvatarProps) {
  return (
    <Avatar
      className={cn(
        AVATAR_SIZE_CLASSES[size],
        onClick && "cursor-pointer hover:opacity-80 transition-opacity",
        className
      )}
      onClick={onClick}
    >
      {imageUrl && (
        <AvatarImage src={imageUrl} alt={name} className="object-cover" />
      )}

      <AvatarFallback className={cn(
        size === "xl" && "text-2xl",
        fallbackClassName
      )}>
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
} 